import { bindActionCreators } from 'redux';
import { connect } from '../../../../react-redux';
import * as modificationActions from '../../../../actions/modifications';
import { featureOn } from '../../../../../common/util/featureCheck';
import { getActiveQuizId, getQuizById } from '../../../../../common/selectors/quizzes';
import StimulusEditInfo from './presenter';
function mapStateToProps(state, props) {
  var quizId = getActiveQuizId(state);
  var quiz = getQuizById(state, quizId);
  return {
    workingStimulus: props.stimulus.getWorkingInstance(),
    errorsShowing: state.getIn(['errorsShowing', props.guid], props.errorsShowing || false),
    stimulusOrientationEnabled: featureOn('customizable_stimulus_orientation'),
    shuffleQuestionsEnabled: quiz.shuffleQuestions
  };
}
function mapDispatchToProps(dispatch) {
  var modActions = bindActionCreators(modificationActions, dispatch);
  return {
    modifyStimulus: modActions.modifyStimulus
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(StimulusEditInfo);